"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _debug = require("../../utils/debug");
var _constants = require("../network/constants");
var _types = require("./types");
var _actions = require("../network/actions");
var _uuid = require("../../utils/uuid");
var _constants2 = require("./constants");
var _actions2 = require("./actions");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _config = _interopRequireDefault(require("../../config"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _lock = _interopRequireDefault(require("../../utils/lock"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
var _primus = _interopRequireDefault(require("./primus"));
var _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
var logger = new _logger.default('service:websocketManager');
var generateId = () => (0, _uuid.generate)().slice(0, 7);
var _enrichEmitter = /*#__PURE__*/new WeakMap();
class WebSocket {
  get mustReconnect() {
    return this._mustReconnect;
  }
  set mustReconnect(value) {
    this._mustReconnect = value;
  }
  constructor(name, _url, params, _emitter) {
    var _this = this;
    _defineProperty(this, "_primus", null);
    _defineProperty(this, "_params", {});
    _defineProperty(this, "_name", null);
    _defineProperty(this, "_url", null);
    _defineProperty(this, "_emitter", null);
    _defineProperty(this, "_serverDelay", 0);
    _defineProperty(this, "_id", null);
    _defineProperty(this, "_spark", undefined);
    _defineProperty(this, "_mustReconnect", true);
    _classPrivateFieldInitSpec(this, _enrichEmitter, {
      writable: true,
      value: emitter => data => emitter(typeof data === 'string' ? "".concat(this._id, " - ").concat(this._spark, " - ").concat(data) : _objectSpread({
        id: this._id
      }, data))
    });
    _defineProperty(this, "log", function () {
      var _this$_spark;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return logger.log('\x1b[34m', _this._id || '', ((_this$_spark = _this._spark) === null || _this$_spark === void 0 ? void 0 : _this$_spark.slice(0, 7)) || '', ...args, '\x1b[0m');
    });
    _defineProperty(this, "warn", function () {
      var _this$_spark2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return logger.warn('\x1b[43m', _this._id || '', ((_this$_spark2 = _this._spark) === null || _this$_spark2 === void 0 ? void 0 : _this$_spark2.slice(0, 7)) || '', ...args, '\x1b[0m');
    });
    _defineProperty(this, "error", function () {
      var _this$_spark3;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return logger.error('\x1b[41m', _this._id || '', ((_this$_spark3 = _this._spark) === null || _this$_spark3 === void 0 ? void 0 : _this$_spark3.slice(0, 7)) || '', ...args, '\x1b[0m');
    });
    _defineProperty(this, "getBackoffTimeFromAttempts", attempts => {
      var {
        websocket: {
          reconnect
        }
      } = _config.default;
      var {
        min,
        max,
        factor
      } = reconnect;
      var result = min;
      for (var cpt = 0; cpt < attempts - 1; cpt++) {
        result = Math.min(result * factor, max || Infinity);
      }
      return result;
    });
    _defineProperty(this, "stringifyWs", ws => {
      var {
        readyState,
        recovery,
        url,
        readable,
        writable,
        disconnect
      } = ws || {};
      return {
        readyState,
        recovery: {
          attempt: recovery.attempt,
          scheduled: recovery.scheduled,
          factor: recovery.factor,
          max: recovery.max,
          min: recovery.min,
          retries: recovery.retries
        },
        url,
        readable,
        writable,
        disconnect
      };
    });
    _defineProperty(this, "setToken", token => {
      var _this$_primus, _this$_params;
      this.error('setToken: token changed', token === null || token === void 0 ? void 0 : token.slice(-10));
      if (this !== null && this !== void 0 && (_this$_primus = this._primus) !== null && _this$_primus !== void 0 && _this$_primus.url) {
        this._primus.url.query = this._primus.url.query.replace(/token=[^&]+/gim, "token=".concat(token));
        this._primus.url.href = this._primus.url.href.replace(/token=[^&]+/gim, "token=".concat(token));
      }
      if (this !== null && this !== void 0 && (_this$_params = this._params) !== null && _this$_params !== void 0 && (_this$_params = _this$_params.queryParameters) !== null && _this$_params !== void 0 && _this$_params.token) {
        this._params.queryParameters.token = token;
      }
    });
    _defineProperty(this, "_createWebsocket", /*#__PURE__*/_asyncToGenerator(function* () {
      var tracePerf;
      var queryString = Object.keys(_this._params.queryParameters).map(key => "".concat(key, "=").concat(_this._params.queryParameters[key])).join('&');
      if (_callbacks.default.isExist('firebasePerf')) {
        try {
          var firebasePerf = _callbacks.default.get('firebasePerf')();
          tracePerf = yield firebasePerf.startTrace('ws');
          tracePerf.putAttribute('env', _config.default.env);
          if (_callbacks.default.isExist('getAppState')) {
            tracePerf.putAttribute('appState', _callbacks.default.get('getAppState')());
          }
        } catch (e) {
          tracePerf = null;
        }
      }
      var ws = new _primus.default("".concat(_this._url, "?").concat(queryString), _this._params.primusOptions);
      _this.log('create', _this._url, _this._params);
      ws.on('open', () => {
        _this._emitter((0, _actions2.websocketConnect)());
        _this.log('on.open in', performance.now() - _this.start, 'ms');
        try {
          var _tracePerf;
          (_tracePerf = tracePerf) === null || _tracePerf === void 0 || _tracePerf.stop();
        } catch (e) {
          tracePerf = null;
        }
      });
      ws.on('error', e => {
        _this.error('on.error', e);
        _errorHandler.default.captureException(e, 'ws:manager', _this.stringifyWs(ws));
        _this._emitter((0, _actions2.websocketFailed)({
          reason: e.message
        }));
      });
      ws.on('data', message => {
        var _message$payload;
        _this.log('on.data', (message === null || message === void 0 ? void 0 : message.code) || '', {
          message
        });
        if (message.code === _types.SERVER_INFO && (_message$payload = message.payload) !== null && _message$payload !== void 0 && _message$payload.now) {
          var now = Date.now();
          _this._serverDelay = now - new Date(message.payload.now).getTime();
        } else {
          _this._emitter(message);
        }
      });

      // Clean ws ending
      // ws.on('end', () => {
      //     this.log('on.end', ws.writable);
      //     this._emitter(websocketEnd(name));
      // });

      // Clean or dirty ws ending
      ws.on('close', () => {
        var _this$_primus2;
        var {
          attempt
        } = ((_this$_primus2 = _this._primus) === null || _this$_primus2 === void 0 || (_this$_primus2 = _this$_primus2.recovery) === null || _this$_primus2 === void 0 ? void 0 : _this$_primus2.attempt) || {};
        _this.log('on.close', ws.writable, attempt);
        _this._emitter((0, _actions2.websocketClose)());
        _this._spark = null;

        // probleme starting WS connexion, need reconnect because strategy is not triggered
        // !TODO: what happened for mobile, does it restart event if mobile try to stop in background ?
        // need to be tested !
        if (_this.mustReconnect && _this._params.primusOptions.strategy) {
          var _this$_primus3, _this$_primus4, _this$_primus4$includ, _this$_params2, _this$_primus5, _this$_primus5$reconn;
          _this.warn('Reconnect WS due to bad handshake with server, starting reconnect', ws.readyState, _this.mustReconnect, (_this$_primus3 = _this._primus) === null || _this$_primus3 === void 0 || (_this$_primus3 = _this$_primus3.recovery) === null || _this$_primus3 === void 0 ? void 0 : _this$_primus3.attempt);
          _this.start = performance.now();
          if (!(_this !== null && _this !== void 0 && (_this$_primus4 = _this._primus) !== null && _this$_primus4 !== void 0 && (_this$_primus4 = _this$_primus4.url) !== null && _this$_primus4 !== void 0 && (_this$_primus4 = _this$_primus4.query) !== null && _this$_primus4 !== void 0 && (_this$_primus4$includ = _this$_primus4.includes) !== null && _this$_primus4$includ !== void 0 && _this$_primus4$includ.call(_this$_primus4, (_this$_params2 = _this._params) === null || _this$_params2 === void 0 || (_this$_params2 = _this$_params2.queryParameters) === null || _this$_params2 === void 0 ? void 0 : _this$_params2.token))) {
            var _this$_params3;
            _this.setToken((_this$_params3 = _this._params) === null || _this$_params3 === void 0 || (_this$_params3 = _this$_params3.queryParameters) === null || _this$_params3 === void 0 ? void 0 : _this$_params3.token);
          }
          (_this$_primus5 = _this._primus) === null || _this$_primus5 === void 0 || (_this$_primus5 = _this$_primus5.recovery) === null || _this$_primus5 === void 0 || (_this$_primus5$reconn = _this$_primus5.reconnect) === null || _this$_primus5$reconn === void 0 || _this$_primus5$reconn.call(_this$_primus5); // enable reconnect strategy
        }
      });

      ws.on('offline', () => {
        _this.log('on.offline');
        _this._emitter((0, _actions.updateConnectedStatus)(false));
      });
      ws.on('online', () => {
        var _this$_primus6, _this$_primus6$reset;
        _this.log('on.online');
        (_this$_primus6 = _this._primus) === null || _this$_primus6 === void 0 || (_this$_primus6 = _this$_primus6.recovery) === null || _this$_primus6 === void 0 || (_this$_primus6$reset = _this$_primus6.reset) === null || _this$_primus6$reset === void 0 || _this$_primus6$reset.call(_this$_primus6);
        _this._emitter((0, _actions.updateConnectedStatus)(true));
      });
      ws.on('reconnect', d => {
        _this._emitter((0, _actions2.websocketConnecting)({
          scheduled: d.scheduled,
          attempt: d.attempt
        }));
        _this.log('on.reconnect', d);
      });

      // should not be triggered because reconnect attempt equal infinity in config
      // but in case of someone want to change that and add a maxAttempt,
      // this should handle when ws cannot triggered after maxAttempts
      ws.on('reconnect failed', e => {
        _this.start = performance.now();
        _this._emitter({
          type: 'WS_RECONNECT_FAILED',
          payload: e
        });
        _this.log('on.reconnect.failed', e);
      });
      return ws;
    }));
    _defineProperty(this, "_command", command => data => {
      this.log('Command:', command, (data === null || data === void 0 ? void 0 : data.code) || '', data);
      if (command === 'write' && data && typeof data === 'object' && !data.transactionId) {
        data.transactionId = (0, _uuid.generate)();
      }
      // remove ICE_CANDIDATE logs
      // if (data && data.code && data.code.indexOf('ICE_CANDIDATE') === -1) {
      //     logger.log(`${command}${this._primus ? '' : '.skip'}`, data);
      // }
      try {
        var _this$_primus7;
        if ((_this$_primus7 = this._primus) !== null && _this$_primus7 !== void 0 && _this$_primus7[command] && typeof this._primus[command] === 'function') {
          this._primus[command](data);
        } else {
          logger.error("Undefined command '".concat(command, "' from websocket manager"));
        }
      } catch (e) {
        logger.error("Error in command '".concat(command, "' from websocket manager"));
        throw e;
      }
    });
    _defineProperty(this, "close", function () {
      _this.mustReconnect = false; // if close is called, it's probably maual trigger, do not auto reconnect
      _this._command('end')(...arguments);
    });
    _defineProperty(this, "open", () => {
      this.mustReconnect = true;
      this.start = performance.now();
      this._command('open')();
    });
    _defineProperty(this, "send", this._command('write'));
    _defineProperty(this, "destroy", this._command('destroy'));
    _defineProperty(this, "getRTT", () => new Promise(resolve => {
      var startAt = Date.now();
      var TIMEOUT = 5000;
      var packetLostTimeout = setTimeout(resolve, TIMEOUT);

      // fetchId seems used to calculate the RTT, this socketid is not really usefull, juste the call is.
      this._primus.fetchId(socketId => {
        if (packetLostTimeout) {
          clearTimeout(packetLostTimeout);
          var backendConnectivityRtt = Date.now() - startAt;
          if (backendConnectivityRtt <= TIMEOUT) {
            this._spark = socketId; // update just in case
            resolve(backendConnectivityRtt);
          }
        }
      });
    }));
    _defineProperty(this, "getServerDelay", () => this._serverDelay);
    // add this to avoid race between opening and opened state.
    this._id = generateId();
    this._emitter = _classPrivateFieldGet(this, _enrichEmitter).call(this, _emitter);
    this._emitter((0, _actions2.websocketConnecting)());
    this.start = performance.now();
    this._name = name;
    this._url = _url;
    this._params = params;
  }
  get emitter() {
    return this._emitter;
  }
  set emitter(emitter) {
    this._emitter = _classPrivateFieldGet(this, _enrichEmitter).call(this, emitter);
  }
}
_class = WebSocket;
_defineProperty(WebSocket, "create", (name, url, params) => /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(function* (emitter) {
    var ws = new _class(name, url, params, emitter);
    ws._primus = yield ws._createWebsocket();
    return ws;
  });
  return function (_x6) {
    return _ref5.apply(this, arguments);
  };
}());
class WebSocketManager {
  constructor() {
    var _this2 = this;
    _defineProperty(this, "wsList", {});
    _defineProperty(this, "qualityMeasureInterval", {});
    _defineProperty(this, "log", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (name) {
        var ws = yield _this2.getWs(name);
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        if (ws) {
          ws.log(...args);
        } else {
          logger.log(name, ...args);
        }
      });
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "close", function () {
      var _this2$wsList$name, _this2$wsList$name$cl;
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants2.WEBSOCKET_NAME;
      _this2.log(name, 'close WS');
      (_this2$wsList$name = _this2.wsList[name]) === null || _this2$wsList$name === void 0 || (_this2$wsList$name$cl = _this2$wsList$name.close) === null || _this2$wsList$name$cl === void 0 || _this2$wsList$name$cl.call(_this2$wsList$name);
    });
    _defineProperty(this, "getWs", function () {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants2.WEBSOCKET_NAME;
      return _this2.wsList[name];
    });
    _defineProperty(this, "getWsList", () => this.wsList);
    _defineProperty(this, "getServerDelay", function () {
      var _this2$wsList$name2, _this2$wsList$name2$g;
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants2.WEBSOCKET_NAME;
      return ((_this2$wsList$name2 = _this2.wsList[name]) === null || _this2$wsList$name2 === void 0 || (_this2$wsList$name2$g = _this2$wsList$name2.getServerDelay) === null || _this2$wsList$name2$g === void 0 ? void 0 : _this2$wsList$name2$g.call(_this2$wsList$name2)) || 0;
    });
    _defineProperty(this, "clearWs", function () {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants2.WEBSOCKET_NAME;
      _this2.log(name, 'clearWs');
      delete _this2.wsList[name];
    });
    _defineProperty(this, "setWs", (name, ws) => {
      this.wsList[name] = ws;
      return ws;
    });
    _defineProperty(this, "lock", new _lock.default());
    // lock to avoid paralelle creation
    _defineProperty(this, "createWebSocket", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* (name, baseUrl, params) {
        return /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(function* (emitter) {
            var _ws$_primus, _ws$_primus2, _ws$_primus2$includes, _params$queryParamete;
            var release = yield _this2.lock.acquire();
            _this2.log(name, 'createWebSocket', baseUrl, params);
            var ws = yield _this2.getWs(name);
            if (ws !== null && ws !== void 0 && (_ws$_primus = ws._primus) !== null && _ws$_primus !== void 0 && (_ws$_primus = _ws$_primus.url) !== null && _ws$_primus !== void 0 && _ws$_primus.query && !(ws !== null && ws !== void 0 && (_ws$_primus2 = ws._primus) !== null && _ws$_primus2 !== void 0 && (_ws$_primus2 = _ws$_primus2.url) !== null && _ws$_primus2 !== void 0 && (_ws$_primus2 = _ws$_primus2.query) !== null && _ws$_primus2 !== void 0 && (_ws$_primus2$includes = _ws$_primus2.includes) !== null && _ws$_primus2$includes !== void 0 && _ws$_primus2$includes.call(_ws$_primus2, params === null || params === void 0 || (_params$queryParamete = params.queryParameters) === null || _params$queryParamete === void 0 ? void 0 : _params$queryParamete.token))) {
              var _ws$_primus3;
              _this2.log(name, 'createWebSocket:token changed, close old ws', ws === null || ws === void 0 || (_ws$_primus3 = ws._primus) === null || _ws$_primus3 === void 0 ? void 0 : _ws$_primus3.readyState);
              ws.setToken(params === null || params === void 0 ? void 0 : params.queryParameters.token);
            }
            return new Promise(resolve => {
              // setTimeout is MANDATORY to make code async, otherwise readyState will not be with updated value.
              setTimeout(() => {
                var _ws$_primus4, _ws$_primus6, _ws$_primus7;
                if ((ws === null || ws === void 0 || (_ws$_primus4 = ws._primus) === null || _ws$_primus4 === void 0 ? void 0 : _ws$_primus4.readyState) === _constants.READY_STATE.OPEN) {
                  var _ws$_primus5;
                  // ws.emitter = emitter;
                  _this2.log(name, 'createWebSocket:skip: reuse opened WS', ws === null || ws === void 0 || (_ws$_primus5 = ws._primus) === null || _ws$_primus5 === void 0 ? void 0 : _ws$_primus5.readyState);
                  // ws.open(); // reconnect ws ? or not, maybe we don't need
                  return resolve(ws);
                  // check if opening in progress OR in case of reconnect, it toggle multiple time with OPENING/CLOSED, add a attemp scheduled check to manage that
                } else if ((ws === null || ws === void 0 || (_ws$_primus6 = ws._primus) === null || _ws$_primus6 === void 0 ? void 0 : _ws$_primus6.readyState) === _constants.READY_STATE.OPENING || !!(ws !== null && ws !== void 0 && (_ws$_primus7 = ws._primus) !== null && _ws$_primus7 !== void 0 && (_ws$_primus7 = _ws$_primus7.recovery) !== null && _ws$_primus7 !== void 0 && (_ws$_primus7 = _ws$_primus7.attempt) !== null && _ws$_primus7 !== void 0 && _ws$_primus7.scheduled)) {
                  var _ws$_primus8;
                  _this2.log(name, 'createWebSocket:skip: opening in progress', ws === null || ws === void 0 || (_ws$_primus8 = ws._primus) === null || _ws$_primus8 === void 0 ? void 0 : _ws$_primus8.readyState);
                  return resolve(ws);
                }
                WebSocket.create(name, baseUrl, params)(emitter).then(newWs => resolve(_this2.setWs(name, newWs)));
              }, 0);
            }).then(ws => {
              release();
              return ws;
            });
          });
          return function (_x5) {
            return _ref4.apply(this, arguments);
          };
        }();
      });
      return function (_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());
  }
}
var _default = exports.default = (0, _debug.addDebugAttribute)(new WebSocketManager(), 'WebSocketManager');
module.exports = exports.default;